var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.categories.length
    ? _c(
        "section",
        {
          staticClass: "analyses-categories-section d-flex flex-column ga-6",
          attrs: { "data-qa": "analyses_categories_section" },
        },
        [
          _c("h2", { staticClass: "text-h6 text--text mb-0" }, [
            _vm._v("\n    Категории анализов\n  "),
          ]),
          _vm._v(" "),
          !_setup.isMobile
            ? _c(_setup.CoreSwiper, {
                staticClass: "analyses-categories-section__slider",
                attrs: {
                  "slides-per-view": "auto",
                  "has-navigation": "",
                  "has-pagination": false,
                  "space-between": 16,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "slides",
                      fn: function ({ slideAttrs }) {
                        return _vm._l(
                          _setup.categoriesWithOther,
                          function (category) {
                            return _c(
                              "div",
                              _vm._b(
                                { key: category.slug },
                                "div",
                                slideAttrs,
                                false
                              ),
                              [
                                _c(_setup.AnalysesCategoryCard, {
                                  attrs: {
                                    name: category.name,
                                    icon: category.icon,
                                    href: category.href,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _setup.onOtherCategoryClick(
                                        category
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          }
                        )
                      },
                    },
                  ],
                  null,
                  false,
                  458789859
                ),
              })
            : _c(_setup.CoreSwiper, {
                attrs: {
                  "slides-per-view": 1,
                  "has-pagination": true,
                  "space-between": 16,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "slides",
                      fn: function ({ slideAttrs }) {
                        return _vm._l(
                          _setup.categoryPages,
                          function (page, pageIndex) {
                            return _c(
                              "div",
                              _vm._b(
                                { key: pageIndex },
                                "div",
                                slideAttrs,
                                false
                              ),
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "analyses-categories-section__grid ga-4",
                                  },
                                  _vm._l(page, function (category) {
                                    return _c(_setup.AnalysesCategoryCard, {
                                      key: category.slug,
                                      attrs: {
                                        name: category.name,
                                        icon: category.icon,
                                        href: category.href,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _setup.onOtherCategoryClick(
                                            category
                                          )
                                        },
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ]
                            )
                          }
                        )
                      },
                    },
                  ],
                  null,
                  false,
                  1742229460
                ),
              }),
          _vm._v(" "),
          _c(_setup.AnalysesOtherCategoriesDrawer, {
            model: {
              value: _setup.isOtherDrawerOpen,
              callback: function ($$v) {
                _setup.isOtherDrawerOpen = $$v
              },
              expression: "isOtherDrawerOpen",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }